<template>
  <el-dialog :title="title" :visible.sync="dialogFormVisible" style="z-index: 99" width="45vw" @close="close">
    <audio ref="audioPlayer" src="@/assets/audio.mp3" controls style="display: none" />
    <audio ref="successAudioPlayer" src="@/assets/success.mp3" controls style="display: none" />
    <!-- 所属用户 -->
    <el-form ref="form" :model="form" label-width="90px" @submit.native.prevent>
      <!-- 包裹单号 -->
      <el-form-item label="包裹单号">
        <el-input ref="code1" v-model.trim="form.order_code" autocomplete="off" clearable
          @keyup.enter.native="handleQuery"></el-input>
      </el-form-item>
      <el-form-item label="库位">
        <el-input ref="code2" v-model.trim="form.storage_location" autocomplete="off" clearable
          @keyup.enter.native="handleQuery1"></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
    </div>

  </el-dialog>
</template>

<script>
import {
  pda_order_warehousing
} from '@/api/xgcApi'
export default {
  name: 'moveLocation',
  components: {},
  props: {
    kor_type: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      title: '',
      gridData: [],
      visible: false,
      loading: false,
      all_list_H: [], //合箱订单的完整list
      allOrderList: [], //全部包裹
      te_code: '', // 合箱后拆箱code
      form: {
        order_code: '',
        order_code1: '',
        order_code2: '',
      },
      dialogFormVisible: false,
      innerVisible: false,
      doPreviewLoading: false, //打印预览loading
      printLoading: false,
      id: '',
      selectRows: '', //多选
      shipping_type: '', // 包裹发货方式
      hid: '',
      codeList: [],
    }
  },
  mounted() {
  },
  beforeDestroy() {
  },
  methods: {
    playSuccessAudio() {
      this.$refs.successAudioPlayer.play()
    },
    // 扫描完包裹，处理回车键按下事件
    handleQuery(event) {
      this.playSuccessAudio()
      this.$nextTick(() => {
        this.$refs.code2.focus()
      })
    },
    // 扫需要移动库位
    handleQuery1(event) {
      pda_order_warehousing(this.form).then(res => {
        this.playSuccessAudio()
        this.form.order_code = ''
        this.form.storage_location = ''
        // this.$emit('change', res.data)
        this.$nextTick(() => {
          this.$refs.code1.focus()
        })
        this.$message({
          type: 'success',
          message: '入库成功',
        })
      }).catch(err => {
        this.form.order_code = ''
        this.form.storage_location = ''
        this.$nextTick(() => {
          this.$refs.code1.focus()
        })
        this.playAudio()
      })

    },

    playAudio() {
      this.$refs.audioPlayer.play()
    },

    // 初始化请求数据
    async showEdit(row) {
      this.title = '包裹入库'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs.code1.focus()
      })
    },
    // 关闭弹窗
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.shipping_type = null
      this.gridData = []
      this.codeList = []
      this.all_list_H = []
      this.allOrderList = []
      for (var key in this.form) {
        this.form[key] = null
      }
      this.dialogFormVisible = false
    },
  },
}
</script>
<style scoped lang="scss">
:deep .el-input--small .el-input__inner {}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
